import {Action} from 'redux';
import {createAction} from '@reduxjs/toolkit';

export const COPY_QUICKSURVEY = 'COPY_QUICKSURVEY';
export const ARCHIVE_QUICKSURVEY = 'ARCHIVE_QUICKSURVEY';

export const copyQuicksurvey = createAction<CopyQuicksurveyPayload>(COPY_QUICKSURVEY);
export const archiveQuicksurvey = createAction<QuicksurveySlugPayload>(ARCHIVE_QUICKSURVEY);
export const pauseQuicksurvey = createAction<QuicksurveySlugPayload>('PAUSE_QUICKSURVEY');
export const resumeQuicksurvey = createAction<QuicksurveySlugPayload>('RESUME_QUICKSURVEY');
export const cancelQuicksurveyModeration = createAction<QuicksurveySlugPayload>(
    'CANCEL_QUICKSURVEY_MODERATION'
);

export interface CopyQuicksurveyPayload {
    clientId?: string;
    slug: string;
}

export interface CopyQuicksurveyAction extends Action {
    payload: CopyQuicksurveyPayload;
}

interface QuicksurveySlugPayload {
    slug: string;
}
